export default {
  betslipConfig: {},
  showBetslip: false,
  ticket: {
    bets: [],
    config: {
      taxes: {
        payin: {
          hideTax: true,
          policy: 'PLPayinTax',
          value: true,
        },
        payout: {
          hideTax: true,
          policy: 'PLPayoutTax',
          value: true,
        },
      },
    },
  },
  futureBets: 1,
  totalStake: 1.00,
  minStake: 1,
  minStakePerBet: 1,
  amountToSplit: 0,
  possibleWinning: 0,
  payinTax: {},
  payoutTax: {},
  taxablePayment: 0,

  minPayment: 0,
  totalPayment: 0,
  paymentToSplit: 0,
  meta: {
    futureBets: 1,
    totalStake: 1.00,
    minStake: 1,
    minStakePerBet: 1,
    amountToSplit: 0,
    possibleWinning: 0,
    payinTax: {},
    payoutTax: {},
    taxablePayment: 0,
  },
  totalStakeChanged: false,
  translations: {},
  bettingEnabled: false,
  payinForbidden: false,
  ticketUnpayable: false,
  ticketRules: {},
  balanceValue: '',
  maxBetAmountErr: false,
  selectedBet: {},
  editMode: false,

  betslipItems: [],
  currentItem: {},
};
